<template>
  <div class="button_element" @click="connect">
    <p>Connect Wallet</p>
  </div>
</template>

<script>
import { bus } from "@/main"
export default {
  name: "Button",
  methods: {
    connect() {
      bus.$emit('connect-wallet')
    }
  }
}
</script>

<style scoped>
.button_element {
  display: flex;
  justify-content: center;

  margin-top: 10px;
  padding: 16px;

  border-radius: 20px;
  background-color: rgba(21, 61, 111, 0.44);
  color: rgb(67, 139, 240);
  font-size: 16px;
  font-weight: 500;

  cursor: pointer;
}
</style>